﻿var jquery = require('jquery');
require('jquery.print');
var WindowModal = require('../../Global/window-modal');
var HabEvents = require('../../Global/habitaclia-events');

(function () {
    'user strict';

    var ModalLegal = function (modalLegalDTO) {
        this.__modalLegalDTO = modalLegalDTO;
    };


    var __registerEvents = function () {

        var self = this;

        jquery('.jqLinkAvisoLegalUsuarios, .js-legal-link').click(function (e) {
            e.preventDefault();
            jquery.ajax({
                url: self.__modalLegalDTO.urlLegal,
                data: ({}),
                success: function (result) {
                    __createModalLegalUsuarios.call(self, result, self.__modalLegalDTO.legalUsuariosComponent, self.__modalLegalDTO.traducciones.titlePoliticaPrivacidad);
                }
            });
        });

        jquery('.js-legal-aviso-link').click(function (e) {
            e.preventDefault();
            jquery.ajax({
                url: self.__modalLegalDTO.urlLegalAviso,
                data: ({}),
                success: function (result) {
                    __createModalLegalUsuarios.call(self, result, '', self.__modalLegalDTO.traducciones.titleAvisoLegalUsuarios);
                }
            });
        });

        jquery('.jqLinkAvisoLegalSoli').click(function (e) {
            e.preventDefault();
            jquery.ajax({
                url: self.__modalLegalDTO.urlLegal,
                success: function (result) {
                    __createModalAvisoLegalSoli.call(self, result, self.__modalLegalDTO.legalSolicitudesComponent);
                }
            });
        });

    };

    var __createModalAvisoLegalSoli = function (sHTML, sAnchor) {
        var oDialog = new WindowModal();
        oDialog.OnReady(__bindEventsModalAvisoLegalSoli);
        oDialog.OnDestroy(__unbindEventsModalAvisoLegalSoli);
        oDialog.CreateWindowModal({
            idSelectorString: 'js-dialog-legal-solicitud',
            dataTitle: '<div class="titleModal">' + this.__modalLegalDTO.traducciones.titleProteccionDatos + '</div><div class="closeModal"></div>',
            dataBody: sHTML,
            dataFooter: '<input type="button" id="idBtnCerrar" name="idBtnCerrar" class="boton" value="'
                + this.__modalLegalDTO.traducciones.cerrar + '" /><a id="printLegalSolicitud" class="sprite imprimir printDialog" title="'
                + this.__modalLegalDTO.traducciones.imprimir + '">' + this.__modalLegalDTO.traducciones.imprimir + '</a>',
            bodyOverflowY: 'scroll',
            bodyHeight: '430px',
        });
        __showLegalComponent.call(this, sAnchor);
    };

    var __bindEventsModalAvisoLegalSoli = function () {
        jquery('#idBtnCerrar, .closeModal').on('click', function () {
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
        });
        jQuery('#printLegalSolicitud').on('click', function (e) {
            e.preventDefault();
            jquery('#wmBody').print();
        });
    };

    var __unbindEventsModalAvisoLegalSoli = function () {
        jquery('#idBtnCerrar, .closeModal').off('click');
        jquery('#printLegalSolicitud').off('click');
    };

    var __createModalLegalUsuarios = function (sHTML, sAnchor, sTitle) {
        var self = this;
        var oDialog = new WindowModal();

        oDialog.OnReady(function () {
            __bindEventsModalLegalUsuarios.call(self, oDialog);
        });
        oDialog.OnDestroy(function () {
            __unbindEventsModalLegalUsuarios.call(self);
        });
        oDialog.CreateWindowModal({
            idSelectorString: 'idHabDialogLegalUsuarios',
            dataTitle: '<div class="titleModal">' + sTitle + '</div><div class="closeModal"></div>',
            dataBody: sHTML,
            dataFooter: '<input type="button" id="idBtnCerrar" name="idBtnCerrar" class="boton" value="'
                +  this.__modalLegalDTO.traducciones.cerrar + '" /><a id="printLegalUsuarios" class="sprite imprimir printDialog" title="'
                +  this.__modalLegalDTO.traducciones.imprimir + '">'
                +  this.__modalLegalDTO.traducciones.imprimir + '</a>',
            modalWidth: '925px',
            modalOverflowY: 'hidden',
            bodyOverflowY: 'scroll',
            bodyHeight: '430px',
            bodyWidth: '100%',
            useDefaultClose: false
        });
        __showLegalComponent.call(this, sAnchor);
    };

    var __bindEventsModalLegalUsuarios = function (oDialog) {
        jquery('#idHabDialogLegalUsuarios #idBtnCerrar, #idHabDialogLegalUsuarios .closeModal').on('click', function () {
            oDialog.CloseWindowModal();
            jquery('.jqLinkAvisoLegalUsuarios').data('m-createaccount-nextaction', '');
            jquery('.jqLinkAvisoLegalUsuarios').data('m-alertafiltro-nextaction', '');
        });
        jquery('#printLegalUsuarios').on('click', function (e) {
            e.preventDefault();
            jquery('#wmBody').print();
        });
    };


    var __unbindEventsModalLegalUsuarios = function () {
        jquery(' #idHabDialogLegalUsuarios #idBtnCerrar, #idHabDialogLegalUsuarios .closeModal').off('click');
        jquery('#printLegalUsuarios').off('click');
    };

    var __showLegalComponent = function (sAnchor) {
        if (sAnchor !== '') {
            jquery(".legal-summary #" + sAnchor).css("display", "flex");
        }
    };

    ModalLegal.prototype = {
        constructor: ModalLegal,
        RegisterEvents: __registerEvents
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = new ModalLegal(ModalLegalDTO);
    }
    else {
        window.ModalLegal = ModalLegal;
    }
})();